import { createContext, useContext } from 'react';
import { type SelectorButtonSize } from './selector-button-presentation';

export type SelectorButtonGroupContextProps = {
  size: SelectorButtonSize;
};

export const SelectorButtonGroupContext = createContext<SelectorButtonGroupContextProps>({
  size: 'standard',
});

export const useSelectorButtonGroupContext = () => useContext(SelectorButtonGroupContext);
